/**
 * 前端错误监控 SDK - Breadcrumb 管理
 * 环形缓冲区，最多保留 maxBreadcrumbs 条
 */
import type { BreadcrumbEntry } from './types';
import { sanitizeBreadcrumbMessage } from './sanitize';

let maxBreadcrumbs = 20;
const breadcrumbs: BreadcrumbEntry[] = [];

export function configureBreadcrumbs(max: number): void {
  maxBreadcrumbs = max;
}

export function addBreadcrumb(
  entry: Omit<BreadcrumbEntry, 'timestamp'> & { timestamp?: string }
): void {
  const crumb: BreadcrumbEntry = {
    ...entry,
    message: sanitizeBreadcrumbMessage(entry.message),
    timestamp: entry.timestamp ?? new Date().toISOString(),
  };
  breadcrumbs.push(crumb);
  // 超出上限时移除最旧的
  while (breadcrumbs.length > maxBreadcrumbs) {
    breadcrumbs.shift();
  }
}

export function getBreadcrumbs(): BreadcrumbEntry[] {
  return [...breadcrumbs];
}

export function clearBreadcrumbs(): void {
  breadcrumbs.length = 0;
}
